import { render, staticRenderFns } from "./Pop-up.vue?vue&type=template&id=2ac799d2&scoped=true"
import script from "./Pop-up.vue?vue&type=script&lang=js"
export * from "./Pop-up.vue?vue&type=script&lang=js"
import style0 from "./Pop-up.vue?vue&type=style&index=0&id=2ac799d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac799d2",
  null
  
)

export default component.exports